function fn_comp_reference() {
    $comp = $(".comp_reference");
    $comp_slider = $comp.find(".slider");
    $comp_slider.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        arrows: true,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
    $comp.find('[data-dynamic-gallery]').each(function(){
        var $gallery_data = $(this).data('dynamic-gallery');
        $(this).on('click', function(e) {
            e.preventDefault();
            $(this).lightGallery({
                dynamic: true,
                dynamicEl: $gallery_data
            })
        });
    });
}